export default __webpack_public_path__ + "static/media/276.fe0cb51f.gif";